import { cn } from '@/lib/cn';

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  return ((parts[0]![0] ?? '') + (parts.length > 1 ? (parts[parts.length - 1]![0] ?? '') : '')).toUpperCase();
}

function hueOf(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) % 360;
  return h;
}

export interface AvatarProps {
  name: string;
  src?: string | null;
  color?: string;
  size?: number;
  className?: string;
  ring?: boolean;
  seed?: string;
}

/** Аватар: загруженная картинка или градиент с инициалами. */
export function Avatar({ name, src, color, size = 32, className, ring, seed }: AvatarProps) {
  const h = hueOf(seed ?? name);
  const style = {
    width: size,
    height: size,
    fontSize: Math.max(10, size * 0.38),
    background: src ? undefined : `linear-gradient(135deg, oklch(0.78 0.12 ${h}), oklch(0.6 0.17 ${(h + 40) % 360}))`,
    boxShadow: ring && color ? `0 0 0 2px var(--lumo-surface), 0 0 0 3.5px ${color}` : undefined,
  };
  return (
    <span className={cn('inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold text-white select-none', className)} style={style} aria-hidden={!src}>
      {src ? <img src={src} alt={name} className="size-full object-cover" draggable={false} /> : initials(name)}
    </span>
  );
}
